
import {Component, Prop, Vue} from "vue-property-decorator";

@Component({})
export default class HeaderBox extends Vue {

  @Prop({required: true})
  headline: string

  @Prop({required: true})
  value: string;
}
